module.exports = "<div class=\"loader-container\" [ngStyle]=\"containerStyle\">\n  <div class=\"loader\" [ngStyle]=\"loaderStyle\">Loading...</div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/atoms/loading/loading.component.html
// module id = ./src/app/shared/atoms/loading/loading.component.html
// module chunks = main